<template>
  <label class="form-check form-switch custom-slider custom-icon-btn" v-tooltip.top="tooltipText">
    <input class="form-check-input" type="checkbox" role="switch" v-model="isActive" @change="onToggle">
    <span class="slider">
      <span class="slider-button"></span>
    </span>
  </label>
</template>

<script>
export default {
  name: 'ArchiveSwitch',
  props: {
    policy: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isActive: !this.policy.archived
    };
  },
  computed: {
    tooltipText() {
      return this.isActive ? 'Archive this policy' : 'Un-archive this policy';
    }
  },
  methods: {
    onToggle() {
      this.$emit('archive', { policy: this.policy, archived: !this.isActive });
    }
  },
  watch: {
    policy: {
      handler(newVal) {
        this.isActive = !newVal.archived;
      },
      deep: true
    }
  }
};
</script>

<style scoped>
/* Custom slider styles */
.custom-slider {
  position: relative;
  width: 42px;
  height: 22px;
  margin-right: 5px;
}

.custom-slider .slider {
  position: absolute;
  top: 1px;
  left: 1px;
  width: 40px;
  height: 20px;
  background-color: #bebebe; /* Grey for unchecked/inactive (Archived) */
  border-radius: 11px;
  cursor: pointer;
  transition: 0.4s;
}

.custom-slider .slider-button {
  position: absolute;
  top: 0px;
  left: 1px;
  width: 20px;
  height: 20px;
  background-color: grey; /* Grey for unchecked/inactive (Archived) */
  border-radius: 50%;
  transition: 0.4s;
}

.form-check-input:checked + .slider {
  background-color: #B5DAC6; /* Light green for active */
}

.form-check-input:checked + .slider .slider-button {
  transform: translateX(20px);
  background-color: #00B972; /* Green color for checked/active */
}

.form-check-input {
  opacity: 0;
  width: 0;
  height: 0;
}
</style>